import { useEffect } from "react";

export function usePageEffects() {
  useEffect(() => {
    // ---- Intersection Observer ----
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    }, observerOptions);

    document
      .querySelectorAll(
        ".blur-vanish, .blur-vanish-left, .blur-vanish-right, .blur-vanish-scale, .stagger-item, .blur-glow, .floating-blur, .text-blur-reveal"
      )
      .forEach((el) => observer.observe(el));

    // ---- Hover effects ----
    const hoverElements = document.querySelectorAll(".enhanced-hover");
    hoverElements.forEach((element) => {
      element.addEventListener("mouseenter", function () {
        this.style.transform = "translateY(-8px) scale(1.02)";
        this.style.boxShadow = "0 20px 40px rgba(92, 39, 254, 0.15)";
        this.style.filter = "drop-shadow(0 8px 16px rgba(0, 0, 0, 0.1))";
      });
      element.addEventListener("mouseleave", function () {
        this.style.transform = "";
        this.style.boxShadow = "";
        this.style.filter = "";
      });
    });

    // ---- Cursor change for interactive elements ----
    const interactiveElements = document.querySelectorAll(
      ".btn-primary, .btn-secondary, .btn-white, .btn-outline, .enhanced-hover"
    );
    interactiveElements.forEach((element) => {
      element.addEventListener("mouseenter", () => {
        document.body.style.cursor = "pointer";
      });
      element.addEventListener("mouseleave", () => {
        document.body.style.cursor = "default";
      });
    });

    // ---- Ripple effect ----
    const buttons = document.querySelectorAll(
      ".btn-primary, .btn-secondary, .btn-white, .btn-outline"
    );
    buttons.forEach((button) => {
      button.addEventListener("click", function (e) {
        const ripple = document.createElement("span");
        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;

        ripple.style.cssText = `
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.6);
          transform: scale(0);
          animation: ripple 0.6s linear;
          width: ${size}px;
          height: ${size}px;
          left: ${x}px;
          top: ${y}px;
          pointer-events: none;
        `;

        this.style.position = "relative";
        this.style.overflow = "hidden";
        this.appendChild(ripple);

        setTimeout(() => ripple.remove(), 600);
      });
    });

    // Ripple animation CSS
    const style = document.createElement("style");
    style.textContent = `
      @keyframes ripple {
        to {
          transform: scale(4);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);

    // ---- Scroll effects ----
    const onScroll = () => {
      const scrolled = window.pageYOffset;
      const heroImage = document.querySelector(".hero-image");
      const header = document.getElementById("header");

      if (scrolled > 100) {
        header?.classList.add("scrolled");
      } else {
        header?.classList.remove("scrolled");
      }

      if (heroImage) {
        const speed = scrolled * 0.3;
        heroImage.style.transform = `translateY(${speed}px)`;
      }
    };
    window.addEventListener("scroll", onScroll);

    // ---- Smooth scrolling ----
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute("href"));
        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });

    // ---- Cleanup ----
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
}
